<template>
  <b-card title="ارسال نوتیفیکیشن">
    <b-form >
      <b-row>
        <b-col cols="6">
          <!-- title-->
          <b-form-group
              label="*عنوان نوتیفیکیشن"
          >
            <b-form-input
                placeholder="عنوان نوتیفیکیشن را وارد کنید"
                v-model="postData.title"
            />
          </b-form-group>

          <b-form-group
              label="*متن نوتیفیکیشن"
          >
            <b-form-input
                placeholder="متن نوتیفیکیشن را وارد کنید"
                v-model="postData.content"
            />
          </b-form-group>

          <b-form-group
              label="*لینک نوتیفیکیشن"
          >
            <b-form-input
                placeholder="لینک نوتیفیکیشن را وارد کنید"
                v-model="postData.link"
            />
          </b-form-group>


          <b-form-group
              label="عکس نوتیفیکیشن"
          >
            <b-form-file
                v-model="file"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".jpg,.svg, .png"
            />
          </b-form-group>








        </b-col>
        <b-col cols="6" >
          <img class="ml-3" src="../../../assets/images/notifications.png" >
        </b-col>


        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="sendNotification"
              variant="success"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BFormRadio,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import axios from "@/libs/axios";
import Swal from 'sweetalert2'
import {$themeConfig} from "@themeConfig";
import uploadService from "@/modules/services/uploadService";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import Image from "@/views/components/image/Image";
import subscriptionRepository from "@/modules/subscriptions/services/subscriptionRepository";
import notification from "@/router/routes/notification";
import notificationRepository from "@/modules/notification/services/notificationRepository";

Vue.use(Croppa);
export default {
  name: "addCategories",
  created() {

  },
  components: {
    Image,
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BImg,
    BFormRadio,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    videoFormComponent,
  },
  data(){
    return {
      file:undefined,
      postData:{
        title: undefined,
        content: undefined,
        photo: undefined,
        link: undefined,
        userId:undefined
      }
    }
  },
  methods: {
  async  sendNotification(){





    try {
      if (this.postData.title  && this.postData.content && this.postData.link ){


        if (this.file) {
          console.log('upload image')
          this.postData.photo = await uploadService.upload(this.file);
        }

        const {data} = await notificationRepository.send(this.postData);
        if (data.isSuccess){
          await Swal.fire({
            confirmButtonText: 'ok',
            title : 'موفقیت',
            html : 'عملیات با موفقیت انجام شد',
            icon: 'success'
          } );
          await this.$router.replace('/notification/list')
        }else {
          await Swal.fire('هشدار', data.message, 'warning');
        }
      }else {
        await  Swal.fire('خطا' , ' نیاز است که فیلد های اجباری را پر کنید' , 'error')
      }
    }catch (e) {
      console.log(e)
      await Swal.fire('خطا', 'مشکلی پیش آمده لطفا با پشتیبانی تماس بگیرید', 'error');
    }







    },

  }
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

</style>
